import { render, staticRenderFns } from "./PatientTelehealthAttendance.vue?vue&type=template&id=5127d9d3&lang=html&"
import script from "./PatientTelehealthAttendance.vue?vue&type=script&lang=js&"
export * from "./PatientTelehealthAttendance.vue?vue&type=script&lang=js&"
import style0 from "./PatientTelehealthAttendance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports